import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { InputNumber } from 'primeng/inputnumber';

@Component({
  selector: 'formly-field-custom-input-number',
  template: `
    <div class="custom-input-number flex justify-content-between flex-wrap">
      <!-- <label>{{ to.label }}</label> -->
      <div class="flex align-items-center">
        <span class="icon-wrapper">
          <i class="pi pi-user icon-left"></i> 
        </span> 
        <label class="ml-3">{{ to.label }}</label>
      </div>
      <div>
        <p-inputNumber #inputNumber
          [formControl]="formControl"
          [showButtons]="true"
          buttonLayout="horizontal"
          [step]="1"
          [min]="0"
          decrementButtonClass="p-button-danger"
          incrementButtonClass="p-button-success"
          incrementButtonIcon="pi pi-plus"
          decrementButtonIcon="pi pi-minus"
          mode="decimal">
        </p-inputNumber>
      </div>
    </div>
  `,
  styles: [`
    .custom-input-number {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px;
      border: 1px solid #dfe1e5;
      border-radius: 8px;
      margin-bottom: 10px;
      background-color: #fff;
    }

    .icon-wrapper {
      background-color: #F2F4F7; 
      border-radius: 50%; 
      display: flex;
      justify-content: center;
      align-items: center;
      width: 32px; 
      height: 32px; 
    }

    .icon-left {
      font-size: 1rem;
      color: #6c757d; 
    }

    .custom-input-number label {
      flex: 1;
      margin-right: 10px;
    }

    .custom-input-number ::ng-deep p-inputNumber {
      flex: 2;
    }

    ::ng-deep .p-inputnumber-buttons-horizontal {
      border: 1px solid #FD7809;
     border-radius: 8px;
    }
    .custom-input-number ::ng-deep p-inputNumber input {
      width: 50px !important; 
      height: 40px !important;
      background-color: #FCE9CF;
      color: #FD7809;
      text-align: center;
      border: none;
      //border: 1px solid #FEBA6D;
      border-radius:0px;
    }

    .custom-input-number ::ng-deep .p-inputnumber-button {
      width: 30px !important;
      height: 40px !important;
    }

    .custom-input-number ::ng-deep .p-inputnumber-button .pi {
      font-size: 12px;
    }

    ::ng-deep .p-button.p-button-success {
      color: #FD7809;
      background: #FCE9CF;
      border: none;
      padding: 6px 10px;
      border-radius: 0px 8px 8px 0px;
    }

    ::ng-deep .p-button.p-button-danger {
      color: #FD7809;
      background: #FCE9CF;
      border: none;
      padding: 6px 10px;
      border-radius: 8px 0px 0px 8px;
    }
    :host ::ng-deep .p-inputtext:hover{
      background-color: #FCE9CF;
      box-shadow: none;
    }

    ::ng-deep input.p-inputtext:hover {
      box-shadow: none !important;
    }

  `]
})
export class CustomInputNumberTypeComponent extends FieldType<FieldTypeConfig> implements OnInit {
  ngOnInit(): void {

  }
  @ViewChild('inputNumber') inputNumber!: InputNumber;

}

